import { Box, Skeleton } from "@mui/material";

const LoadingSkeleton = () => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
    <Skeleton variant="rectangular" height={200} />
    <Skeleton variant="rectangular" height={200} />
    <Skeleton variant="rectangular" height={200} />
  </Box>
);

export default LoadingSkeleton;
